export const RANKINGS_SERVICE = 'rankings-service';
export const SUSPENSION_SERVICE = 'suspension-service';
export const TOURNAMENT_ENGINE = 'tournamentEngine';
export const COMPETITION_ENGINE = 'competitionEngine';
